/**
 * A global namespace for `Insert` key.
 * e.which = 45 equivalent
 */
const keyInsert = "Insert";

export default keyInsert;
